import React, { useEffect, useState } from 'react';
type Mention = {
  id: number;
  name: string;
};

import style from '../../../../assets/styles/commentSection.module.css';
import { CallWithAuth } from '../../../../action/apiActions';
import { GET_TASKS_COMMENTS, TAGGED_USERS, TASKS_COMMENTS } from '../../../../action/apiPath';
import ClockIcon from '../../../../assets/images/clockIcon.svg';
import { useToast } from '../../common/Toast';
import { Pagination } from '../../common/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { createActivity, recentActivity, viewfetchActivities } from '../../../../redux/action';
interface Comment {
  id: number;
  user_name: string; // Author of the comment
  comment: string; // The actual comment text
  created_at: string; // Timestamp of the comment
}
interface CommentSectionProps {
  taskId?: number;
}
interface User {
  id: number;
  name: string;
}

interface ApiResponse {
  status: number;
  message: string;
  data: {
    status: number;
    data: User[];
  };
}

import { MentionsInput, Mention } from 'react-mentions';

const CommentSection: React.FC<CommentSectionProps> = ({ taskId }) => {
  const toast = useToast();
  const me = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const [comments, setComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [last, setLast] = useState(5);
  const [inputPage, setInputPage] = useState(currentPage);
  const [activeTab, setActiveTab] = useState<'comments' | 'activities'>('comments');
  const [limit] = useState<number>(15); // Comments per page
  const [viewComments, setViewComments] = useState<any>({ results: [], count: 0 });
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const userId = userInfo.id;
  const { first_name, last_name } = userInfo;
  const user_name = `${first_name} ${last_name}`;
  const orgId = Number(localStorage.getItem('selectedOrgId'));
  const dispatch = useDispatch();
  const { activityList, fetchActivityList } = useSelector((state: any) => state.GetAllData);
  const [taggedUser, setTaggedUser] = useState<any>([]);
  // Define full month names
  const monthNames = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  const currentDate = new Date().toLocaleDateString();
  const getActivityMessage = (task_status_id: number, approvers: string[], is_first: boolean) => {
    const statusMap: { [key: number]: string } = {
      1: 'To-Do',
      2: 'In Process',
      3: 'In Review',
      4: 'Approved',
      5: 'Posted Comment',
      6: 'Assignee Modify',
      7: 'Approver Modify',
    };

    const taskStatus = statusMap[task_status_id] || 'Unknown';
    const normalizedStatus = taskStatus.toLowerCase();

    switch (normalizedStatus) {
      case 'approved':
        return (
          <>
            <span className={style.commentByClass}>has</span>
            <span>{taskStatus}</span>
            <span className={style.commentByClass}>the task</span>
          </>
        );

      case 'to-do':
        return (
          <>
            {!is_first ? (
              <>
                <span className={style.commentByClass}>has moved task</span>
                <span> {taskStatus}</span>
              </>
            ) : (
              <>
                <span className={style.commentByClass}> is the assignee.</span>
                {approvers.length > 0 && (
                  <>
                    <br />
                    <span className={style.userName}>{approvers.join(' and ')}</span>
                    <span className={style.commentByClass}>
                      {approvers.length === 1 ? ' has been added as an approver.' : ' have been added as approvers.'}
                    </span>
                  </>
                )}
              </>
            )}
          </>
        );

      case 'in review':
        return (
          <>
            <span className={style.commentByClass}>has sent the task for</span>
            <span>{taskStatus}</span>
          </>
        );

      case 'in process':
        return (
          <>
            <span className={style.commentByClass}>has started the task</span>
            <span>{taskStatus}</span>
          </>
        );

      case 'posted comment':
        return (
          <>
            <span className={style.commentByClass}>has</span>
            <span>{taskStatus}</span>
          </>
        );

      case 'assignee modify':
        return (
          <>
            <span className={style.commentByClass}>has been assigned as </span>
            <span className={style.userName}>Assignee</span>
          </>
        );

      case 'approver modify':
        return (
          <>
            <span className={style.commentByClass}>has been assigned as </span>
            <span className={style.userName}>Approver</span>
          </>
        );

      default:
        return <span>{taskStatus}</span>; // Fallback for unknown statuses
    }
  };

  const formatCommentTime = (timestamp: any) => {
    if (!timestamp || typeof timestamp !== 'string') return 'Invalid Date';

    const parseISODate = (ts: any) => new Date(ts);
    const parseCustomDate = (ts: any) => {
      const parts = ts.split(' | ');
      if (parts.length !== 2) return null;

      const [datePart, timePart] = parts;
      const dateParts = datePart.split('/').map(Number);
      if (dateParts.length !== 3) return null;

      const [month, day, year] = dateParts;
      if (!/am|pm/.test(timePart)) return null;

      const [time, modifier] = timePart.split(' ');
      const [hours, minutes] = time.split(':').map(Number);
      let adjustedHours;
      if (modifier === 'pm' && hours !== 12) {
        adjustedHours = hours + 12;
      } else if (modifier === 'am' && hours === 12) {
        adjustedHours = 0;
      } else {
        adjustedHours = hours;
      }

      return new Date(year, month - 1, day, adjustedHours, minutes);
    };

    const commentDate = timestamp.includes('T') ? parseISODate(timestamp) : parseCustomDate(timestamp);
    if (!commentDate || isNaN(commentDate.getTime())) return 'Invalid Date';

    const now = new Date();
    const isSameDay = now.toDateString() === commentDate.toDateString();

    const displayHours = commentDate.getHours() % 12 || 12;
    const displayMinutes = String(commentDate.getMinutes()).padStart(2, '0');
    const ampm = commentDate.getHours() >= 12 ? 'pm' : 'am';
    const formattedTime = `${displayHours}:${displayMinutes} ${ampm}`;

    if (isSameDay) return `Today at ${formattedTime}`;

    return `${commentDate.getDate()} ${monthNames[commentDate.getMonth()]} ${commentDate.getFullYear()}, ${formattedTime}`;
  };

  const convertToIST = (dateString: string): string => {
    const date = new Date(dateString);
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    const istDate = new Date(date.getTime() + istOffset);

    const now = new Date();
    const diffMs = now.getTime() - istDate.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const day = istDate.getDate().toString().padStart(2, '0');
    const hours24 = istDate.getHours();
    const minutes = istDate.getMinutes().toString().padStart(2, '0');

    // Convert 24-hour format to 12-hour format with AM/PM
    const hours12 = hours24 % 12 || 12; // Convert 0 to 12 for AM
    const amPm = hours24 < 12 ? 'am' : 'pm';

    // Format for older dates
    const month = monthNames[istDate.getMonth()];
    const year = istDate.getFullYear();

    // If today
    if (diffHours < 24 && istDate.getDate() === now.getDate()) {
      return `Today at ${hours12}:${minutes} ${amPm}`;
    }

    return `${day} ${month} ${year}, ${hours12}:${minutes} ${amPm}`;
  };
  const refreshActivity = () => {
    dispatch(recentActivity(orgId));
  };
  const handleSubmit = async () => {
    if (value.trim()) {
      const newComment = {
        task_id: taskId,
        comment: renderHTML(value),
        user_id: userId,
        created_at: currentDate,
        tagged_user: [...new Set(taggedUser)].map((item: any) => +item),
      };
      setLoading(true);
      try {
        // First API call to submit the comment
        const response = await CallWithAuth('POST', TASKS_COMMENTS, newComment);

        if (response && typeof response === 'object' && 'status' in response) {
          const addComment: Comment = {
            id: comments.length + 1,
            user_name: user_name,
            comment: comment,
            created_at: currentDate, // Correctly formatted date
          };

          setComments((prev) => [addComment, ...prev]);
          setComment('');
          setValue('');
          if (response?.res?.data.status === 200) {
            const successMessage = response?.res?.data.message;
            toast?.remove('all');
            toast?.add(successMessage, 'success');
            // Dispatch Redux action instead of calling API directly
            dispatch(createActivity(taskId, userId, 5, currentDate, toast));
            taggedUser.map((userId: any) =>
              dispatch(createActivity(taskId, +userId, 8, currentDate, toast, refreshActivity))
            );
            fetchComments(currentPage);
            dispatch(recentActivity(orgId));
            setTaggedUser([]);
          } else {
            const errorMessage = response?.res?.data.error;
            toast?.remove('all');
            toast?.add(errorMessage, 'error');
          }
        } else {
          throw new Error('Failed to submit comment');
        }
      } catch (error: any) {
        console.error('Error:', error);
        alert(error.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    }
  };

  // Fetch comments from API
  const fetchComments = async (page: number) => {
    setLoading(true);
    try {
      const response = await CallWithAuth('GET', `${GET_TASKS_COMMENTS}${taskId}/?limit=${limit}&page=${currentPage}`);

      if (response?.res && response.res.status === 200) {
        // Ensure response has required fields
        const formattedComments = response.res.data;

        setViewComments(formattedComments);
      } else {
        console.error('Unexpected response format:', response);
      }
    } catch (error) {
      console.error('Error fetching comments:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (viewComments?.count) {
      setLoading(false);
      const totalResults = viewComments?.count;
      // If the current offset is greater than the total results,
      // reset to first page
      if (offset >= totalResults && totalResults > 0) {
        setOffset(0);
        setCurrentPage(1);
        setInputPage(1);
        setLast(Math.min(15, totalResults));
        setTotalCount(offset);
      } else {
        if (totalResults) {
          setTotalCount(totalResults);
          setLast(Math.min(offset + 15, totalResults));
        }
        if (!totalResults) {
          setTotalCount(0);
          setLast(1);
          setOffset(0);
        }
      }
    }
  }, [viewComments]);

  useEffect(() => {
    if (fetchActivityList?.count) {
      setLoading(false);
      const totalResults = fetchActivityList?.count;
      // If the current offset is greater than the total results,
      // reset to first page
      if (offset >= totalResults && totalResults > 0) {
        setOffset(0);
        setCurrentPage(1);
        setInputPage(1);
        setLast(Math.min(15, totalResults));
        setTotalCount(offset);
      } else {
        if (totalResults) {
          setTotalCount(totalResults);
          setLast(Math.min(offset + 15, totalResults));
        }
        if (!totalResults) {
          setTotalCount(0);
          setLast(1);
          setOffset(0);
        }
      }
    }
  }, [fetchActivityList]);

  useEffect(() => {
    if (activityList) {
      setLoading(false);
    }
  }, [comments]);

  // Fetch comments on page load and page change
  useEffect(() => {
    fetchComments(currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchActivities();
  }, [currentPage]);

  const fetchActivities = async () => {
    setLoading(true);
    dispatch(viewfetchActivities(orgId, taskId, limit, currentPage));
  };

  const handleTabSwitch = (tab: 'comments' | 'activities') => {
    setActiveTab(tab);
    setCurrentPage(1); // Reset to first page
    setOffset(0); // Reset offset
    if (tab === 'activities') {
      fetchActivities();
    }
  };
  const [comment, setComment] = useState<string>('');
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
    fetchUsers();
    console.log(totalCount, last, inputPage);
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await CallWithAuth('GET', TAGGED_USERS(orgId, taskId));
      if (response?.res?.data?.status === 200) {
        setUsers(response?.res?.data?.data);
      } else {
        console.error('Unexpected response format:', response);
      }
    } catch (error) {
      console.error('Error fetching users', error);
    }
  };

  // mentions

  const [value, setValue] = useState('');
  const [prevMentions, setPrevMentions] = useState<string[]>([]);
  const handleAddMention = (id: string | number) => {
    const tagged_user = [...taggedUser, id];
    setTaggedUser(tagged_user);
  };

  const extractMentionIds = (text: string) => {
    const mentionRegex = /@\[(.*?)\]\((.*?)\)/g;
    const ids: string[] = [];
    let match;
    while ((match = mentionRegex.exec(text)) !== null) {
      ids.push(match[2]); // Extract ID
    }
    return ids;
  };

  const handleChangeMention = (event: any, updatedValue: any) => {
    const newValue = event.target.value;
    const newMentions = extractMentionIds(newValue);
    // Detect removed mentions
    prevMentions.forEach((id) => {
      if (!newMentions.includes(id)) {
        console.log('Removed user ID:', id);
      }
    });

    setPrevMentions(newMentions);
    setValue(newValue);
    const tagged_user = [...newMentions];
    setTaggedUser(tagged_user);
  };
  const renderCommentSection = (viewComments: any) => {
    return viewComments.results.length > 0 ? (
      viewComments.results.map((comment: Comment) => (
        <div key={comment.id} className={style.comment}>
          <div className={style.commentContent}>
            <p className={style.commentAuthor}>
              <span>Comment</span> <span className={style.commentByClass}>By</span> {comment.user_name}
            </p>
            <div dangerouslySetInnerHTML={{ __html: comment.comment }} className={style.commentText}></div>
          </div>
          <div className={style.commentTimeDiv}>
            <p className={style.commentTime}>
              <span className={style.clockIcon}>
                <img src={ClockIcon} alt="Clock icon" />
              </span>{' '}
              {convertToIST(comment.created_at)}
            </p>
          </div>
        </div>
      ))
    ) : (
      <p className={style.noComments}>No comments yet.</p>
    );
  };
  const renderHTML = (text: string) => {
    return text.replace(
      /@\[(.*?)\]\((.*?)\)/g,
      `<span contenteditable="false" style="background-color: rgb(135, 206, 235,0.6); padding: 2px; border-radius: 4px; color: black; font-weight: 500; margin-right: 5px;" class="mention-tag">$1</span>`
    );
  };
  const renderActivitySection = (fetchActivityList: any) => {
    return (fetchActivityList?.results || []).length > 0 ? (
      fetchActivityList.results.map(
        (activity: {
          id: number;
          assignee: string;
          approvers: string[];
          approved_by: string;
          user: string;
          task_status: string;
          task_status_id: number;
          created_at: string;
          is_first: boolean;
          tagged_by?: any;
          tagged_user?: any;
        }) => (
          <div key={activity.id} className={style.activity}>
            <p className={style.activityText}>
              {activity.task_status_id !== 8 ? (
                <>
                  <span className={style.userName}>{activity.user}</span>

                  <span className={`${style.taskStatus} ${style[activity.task_status.toLowerCase()]}`}>
                    {getActivityMessage(activity.task_status_id, activity.approvers, activity.is_first)}
                  </span>
                </>
              ) : (
                <>
                  <span className={style.userName}>{activity?.tagged_by?.name}</span>

                  <span className={`${style.taskStatus} ${style[activity.task_status.toLowerCase()]}`}>
                    {` has tagged ${me.id === activity?.tagged_user?.user_id ? 'you' : activity?.tagged_user?.user_name}`}
                  </span>
                </>
              )}
            </p>

            <div className={style.activityTime}>
              <span className={style.clockIcon}>
                <img src={ClockIcon} alt="Clock icon" />
              </span>
              {formatCommentTime(activity.created_at)}
            </div>
          </div>
        )
      )
    ) : (
      <p className={style.noActivities}>No activities yet.</p>
    );
  };
  return (
    <div className={style.commentSection}>
      <div className={style.commentSectionContainer}>
        {/* Tabs for switching between Comments & Activities */}
        <div className={style.tabs}>
          <button
            className={`${style.tab} ${activeTab === 'comments' ? style.activeTab : ''}`}
            onClick={() => handleTabSwitch('comments')}
          >
            Comments
          </button>
          <button
            className={`${style.tab} ${activeTab === 'activities' ? style.activeTab : ''}`}
            onClick={() => handleTabSwitch('activities')}
          >
            Activities
          </button>
        </div>

        {/* Comments Section */}
        {activeTab === 'comments' && (
          <>
            <div className="mention-input-containeLr">
              <MentionsInput
                value={value}
                onChange={(event, newValue) => handleChangeMention(event, newValue)}
                className="mentions-textarea"
                placeholder="Mention people using '@'"
              >
                <Mention
                  trigger="@"
                  data={users.map((user) => ({ id: user.id, display: `@${user.name}` }))}
                  className="mention-tag"
                  onAdd={handleAddMention}
                />
              </MentionsInput>
            </div>
            <div
              style={{ position: 'relative', left: 0, right: 0, top: 10, bottom: 0, width: '100%' }}
              className={style.sendButton}
            >
              <button
                onClick={handleSubmit}
                className={`${style.tab} ${style.commentTab} ${style.activeTab}`}
                disabled={loading || value.trim() === ''}
              >
                Comment
              </button>
            </div>
            <div style={{ marginTop: 27 }} className={style.commentsList}>
              {loading ? <p>Loading...</p> : renderCommentSection(viewComments)}
            </div>
          </>
        )}

        {/* Activities Section */}
        {activeTab === 'activities' && (
          <div className={style.activitiesList}>
            {loading ? <p>Loading...</p> : renderActivitySection(fetchActivityList)}
          </div>
        )}

        {/* Render Pagination Only Once */}
        {((activeTab === 'comments' && viewComments?.count > limit) ||
          (activeTab === 'activities' && fetchActivityList?.count > limit)) && (
          <div className={style.paginationForComments}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              limit={limit}
              totalCount={activeTab === 'comments' ? viewComments?.count : fetchActivityList?.count}
              offset={offset}
              setOffset={setOffset}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentSection;
